import apiClient from './client'

export interface ThemeSettings {
  theme_company_name: string
  theme_app_name: string
  theme_tagline: string
  theme_login_message: string
  theme_copyright: string
  theme_logo_url: string
  theme_favicon_url: string
  theme_primary_color: string
  theme_secondary_color: string
  theme_accent_color: string
  theme_sidebar_bg: string
  theme_sidebar_text: string
  theme_company_color_sidebar: string
  theme_page_bg: string
  theme_card_bg: string
  theme_card_text: string
  theme_login_bg: string
  theme_login_card_bg: string
  theme_login_text: string
  theme_company_color_login: string
}

export const themeApi = {
  // Get theme settings (admin)
  getSettings: async (): Promise<ThemeSettings> => {
    const response = await apiClient.get('/admin/theme/')
    return response.data
  },

  // Update theme settings
  updateSettings: async (settings: Partial<ThemeSettings>): Promise<{
    status: string
    message: string
    updated: string[]
  }> => {
    const response = await apiClient.post('/admin/theme/', settings)
    return response.data
  },

  // Upload logo
  uploadLogo: async (file: File): Promise<{
    status: string
    message: string
    logo_url: string
  }> => {
    const formData = new FormData()
    formData.append('logo', file)
    const response = await apiClient.post('/admin/theme/upload-logo/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Remove logo (revert to default)
  removeLogo: async (): Promise<{
    status: string
    message: string
  }> => {
    const response = await apiClient.delete('/admin/theme/upload-logo/')
    return response.data
  },
}
